import { Link } from 'react-router-dom';
import Header, { HeaderRenderProps } from '../../header';

const HeaderRender = ({ breadcrumbs, lastIdx }: HeaderRenderProps) => (
    <section className="page-head catalog-page-head">
        <div className="wrap">
            <div className="ui-breadcrumb">
                <div className="ui-breadcrumb__inner">
                    <a href="/" className="ui-breadcrumb__item">
                        Главная
                    </a>
                    {breadcrumbs.map(({ name, url }, idx) =>
                        idx === lastIdx ? (
                            <div key={url} className={'ui-breadcrumb__item ui-breadcrumb__item--current'}>
                                {name}
                            </div>
                        ) : (
                            <Link key={url} to={url} className={'ui-breadcrumb__item'}>
                                {name}
                            </Link>
                        )
                    )}
                </div>
            </div>
            <h1>{breadcrumbs[lastIdx].name}</h1>
        </div>
    </section>
);

function NewIekHeader() {
    return <Header render={HeaderRender} />;
}

export default NewIekHeader;
